import { takeLatest, put } from 'redux-saga/effects';
import { ProjectId, UserId } from 'api/models';
import { ProjectAPI } from 'api/project';
import { add } from 'stores/memberships';
import { getProjectMembers } from '../actions';
import { setMembersLoading, setMembersError } from '../slice';
function* getProjectMembersManager(action) {
    const { payload } = action;
    try {
        yield put(setMembersLoading(true));
        const { members = [] } = yield ProjectAPI.getMembers(payload.projectId);
        yield put(add({
            projectId: ProjectId(payload.projectId),
            memberships: members.map(({ user: { userId }, permissionSet: { permissionSetType: memberType }, joinedAt })=>({
                    userId: UserId(userId),
                    memberType,
                    joinedAt
                }))
        }));
    } catch (unused) {
        yield put(setMembersError(true));
    } finally{
        yield put(setMembersLoading(false));
    }
}
export const watchGetProjectMembers = function*() {
    yield takeLatest(getProjectMembers.type, getProjectMembersManager);
};
